module.exports = __webpack_public_path__ + "img/ydkzdzzl.a8a1174b.png";